import isToday from "date-fns/isToday";

export const getMostRecentLoginDateExcludingToday = (user) => {
  if (!user.login_history) return null;
  return user.login_history
    .map((timestamp) => new Date(timestamp * 1000))
    .filter((date) => !isToday(date))
    .slice(-1)[0];
};
